import { createFileRoute } from "@tanstack/react-router";
import { replaceWithBareModule } from "@/app/module-address";
import { PendingSurface } from "@/components/feedback/pending-surface";

export const Route = createFileRoute("/_authenticated/")({
  beforeLoad: ({ location }) => {
    replaceWithBareModule("/", location);
  },
  component: () => <PendingSurface titleKey="nav.home" />,
});
